/*
 * @Author: wangwei18
 * @Date: 2024-12-06 11:43:20
 * @LastEditors: dongjing03 dongjing03@kuaishou.com
 * @LastEditTime: 2025-06-25 11:57:01
 * @Description:
 */
import React, { useImperativeHandle, useMemo } from 'react';
import intl from '@/internationalzation/intl';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import ReactMarkdown, { Options } from 'react-markdown';
import extensions from './extensions';
import classNames from 'classnames';
import './index.less';
import remarkDirective from 'remark-directive';
import { remarkCustomContainer, removeFootnotes } from './remarkContainer';
import { filterMarkdown } from '@src/utils/xss-protection';
import rehypeWebCard from './rehypeWebCard';

/**
 * 将「非 http(s)」的 scheme 冒号换成 HTML 实体，避免 GFM autolink 把 agent:main:main、333:sss 等当链接解析导致截断/换行。
 * 用 &#58; 替代 :，解析器不会识别为 autolink，渲染时仍显示为冒号。
 * scheme:// 形式的真实 URL 协议（kim://、ftp:// 等）不转义。
 */
// function escapeNonHttpSchemeColon(source: string): string {
//   return source.replace(
//     /\b(?!https?:)([a-zA-Z0-9+.-]+):(?!\/\/)/g,
//     (_, scheme: string) => `${scheme}&#58;`,
//   );
// }

/**
 * react-markdown v8 内置 uriTransformer 白名单只允许 http/https/mailto/tel，
 * 这里放行所有非 javascript: 的协议，支持 kim:// 等自定义 scheme 深链接。
 */
function customUriTransformer(uri: string): string {
  if (/^javascript:/i.test(uri)) return 'javascript:void(0)';
  return uri;
}

const remarkPlugins: Options['remarkPlugins'] = [
  remarkDirective,
  remarkCustomContainer,
  [
    remarkGfm,
    {
      singleTilde: false,
    },
  ],
  removeFootnotes,
];
// rehypeWebCard 暂时去掉，等后期有需求再添加
// kim 里面显示会有问题
const rehypePlugins: Options['rehypePlugins'] = [[rehypeRaw, {}]];
export interface Props {
  source: string;
  className?: string;
  withFilter?: boolean;
}
const source1 = intl.t(
  '# 标题 [链接](https://www.baidu.com) ![图片](https://www.baidu.com/img/flexible/logo/pc/result.png) ```js const a = 1; console.log(a); ``` ```css .class { color: red; } ``` !@[png](resourceId=1237861283746&resourceName=我是123&resourceSize=918273912)',
  {},
);
export const MdRender = ({ source, className, withFilter = true }: Props) => {
  const components = useMemo(() => {
    return extensions.reduce(
      (acc, item) => {
        acc[item.tag] = item.componentFn;
        return acc;
      },
      {} as Record<string, React.ComponentType<any>>,
    );
  }, []);
  if (!source) return null;
  // 先转义非 http(s) 的 scheme 冒号，再 XSS 过滤，避免 GFM autolink / 过滤逻辑导致 agent:main:main 等被截断
  // const escapedSource = escapeNonHttpSchemeColon(source);
  const sanitizedSource = withFilter ? filterMarkdown(source) : source;

  return (
    <ReactMarkdown
      components={components}
      className={classNames('markdown-wrapper', className)}
      remarkPlugins={remarkPlugins}
      rehypePlugins={rehypePlugins}
      transformLinkUri={customUriTransformer}
    >
      {extensions.reduce((acc, item) => {
        return item.sourcePipeline(acc);
      }, sanitizedSource)}
    </ReactMarkdown>
  );
};
export default MdRender;
